import React from "react"
import Select from "react-select";

// Reusable TextField Component
export const TextField = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  required = false,
  type = "text",
  fieldType = "text",
  disabled = false,
  error = false,
  errorMessage = ""
}) => (
  <div className="flex flex-col">
    <label className="font-semibold mb-2">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <input
      type={fieldType}
      name={name}
      value={value}
      onChange={e => {
        const newValue = e.target.value;
        if (type === "phone" && !/^[0-9+\-]*$/.test(newValue)) return;
        onChange(e);
      }}
      onBlur={onBlur}
      placeholder={placeholder}
      required={required}
      className={`w-full px-4 py-2 rounded-md border-2 ${error ? "border-red-500" : "border-[#A8D3FC]"}`}
      disabled={disabled}
    />
    {error && <div className="text-red-500 text-sm mt-1">{errorMessage}</div>}
  </div>
);

// Reusable CustomSelect Component
export const CustomSelect = ({ label, value, onChange, options = [], required = false, disabled = false }) => (
  <div className="flex flex-col">
    <label className="font-semibold mb-2">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <Select
      isDisabled={disabled}
      value={options.find(opt => opt.value === value) || null} // Ensure value resets correctly
      onChange={onChange}
      options={options}
      required={required}
      className="block w-full"
      styles={{
        control: (base, state) => ({
          ...base,
          borderWidth: "2px",
          borderColor: state.isFocused ? "rgb(0, 95, 204)" : "#A8D3FC",
          "&:hover": { borderColor: "#CCE6FE" },
          borderRadius: "0.375rem",
          padding: "2px 5px",
        }),
        menu: base => ({
          ...base,
          borderRadius: "0.75rem",
          zIndex: 1000,
          overflowY: "auto",
        }),
      }}
      maxMenuHeight={'120px'}
    />
  </div>
);